import React from 'react';
import { COMPANY } from '../../../content/staticAssets';

/** Archived from the live /company page via SHOW_COMPANY_PEOPLE. Keep photos and bios in-repo. */
// Team data for easy updates
const teamMembers = [
  {
    id: 1,
    name: "Michael Fawehinmi",
    title: "Executive Director",
    image: COMPANY.leadership.michael,
    bio: "With over 12 years of experience leading analytics and engineering initiatives, Michael has driven enterprise data and automation strategies for companies such as NetApp Inc. and Salesforce. He has a proven track record of building scalable data ecosystems, integrating workforce automation, and guiding digital transformation across global organizations.",
    isCEO: true,
    imagePosition: "object-[50%_38%]"
  },
  {
    id: 2,
    name: "Aparna Ramani",
    title: "Director of Data Engineering",
    image: COMPANY.leadership.aparna,
    bio: "With 12+ years in software architecture and AI systems, Aparna has led large-scale data engineering projects at Microsoft and Oracle. She specializes in building high-performance data pipelines, enterprise integrations, and advanced machine learning infrastructure that enable companies to scale their analytics capabilities.",
    isCEO: false,
    imagePosition: "object-center"
  },
  {
    id: 3,
    name: "Rajesh Patel",
    title: "Vice President of Data Science",
    image: COMPANY.leadership.rajesh,
    bio: "Rajesh holds a PhD in Applied Mathematics from Worcester Polytechnic Institute (WPI) and has led analytics teams at Accenture. He brings deep expertise in predictive modeling, NLP, and statistical forecasting, transforming complex problems into actionable insights for Fortune 500 clients in finance, retail, and healthcare.",
    isCEO: false,
    imagePosition: "object-center"
  },
  {
    id: 4,
    name: "Ananya Iyer",
    title: "Managing Director of Client Solutions",
    image: COMPANY.leadership.ananya,
    bio: "Ananya has a decade of experience in management consulting and technology implementation, having previously worked with Infosys. She bridges business needs with technical solutions, ensuring clients maximize the value of their data and digital transformation initiatives.",
    isCEO: false,
    imagePosition: "object-center"
  },
  {
    id: 5,
    name: "Prateek Shah",
    title: "Principal Cloud Architect",
    image: COMPANY.leadership.prateek,
    bio: "Prateek is an AWS and Azure certified architect with over 10 years of experience designing cloud and hybrid infrastructure for companies like IBM and Cisco. His expertise spans enterprise-grade security, DevOps automation, and building scalable environments to support data-driven organizations.",
    isCEO: false,
    imagePosition: "object-center"
  },
  {
    id: 6,
    name: "Ahmed Benallouche",
    title: "Director of Recruiting Operations",
    image: COMPANY.leadership.ahmed,
    bio: "Ahmed leads global recruiting operations and talent strategy. With over 15 years of experience at Randstad and Adecco, he has built and scaled recruiting pipelines across technology, finance, and manufacturing. His focus is on operational excellence, workforce planning, and creating candidate experiences that attract top global talent.",
    isCEO: false,
    imagePosition: "object-center"
  }
];

function Leadership() {
  return (
    <div>
      <section
        className="relative py-12 sm:py-16 overflow-hidden bg-white"
        style={{
          backgroundImage:
            "linear-gradient(135deg, #e0f2fe 0%, #f0f9ff 100%), url('https://www.toptal.com/designers/subtlepatterns/patterns/dots.png')",
          backgroundRepeat: "repeat",
          backgroundBlendMode: "lighten",
        }}
      >
        {/* Leadership Team Grid */}
        <div className="relative mx-auto max-w-7xl px-6 lg:px-8 mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-extrabold text-logo-dark-blue mb-4">Our Leadership Team</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Meet the experienced professionals driving innovation and delivering exceptional results for our clients.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member) => (
              <div key={member.id} className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex flex-col items-center text-center">
                  <img
                    src={member.image}
                    alt={member.name}
                    className={`h-28 w-28 rounded-full border-3 border-logo-light-blue shadow-lg object-cover ${member.imagePosition} mb-4 transition-transform duration-300 hover:scale-110`}
                  />
                  <h4 className="text-xl font-bold text-logo-dark-blue mb-1">{member.name}</h4>
                  <p className="text-sm font-semibold text-logo-blue mb-4">{member.title}</p>
                  <p className="text-ink-600 leading-relaxed text-base">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Leadership;
